import React from "react";
import { motion } from "framer-motion";


const DEFAULT_BENEFITS = [
  "כרטיסים שמורים: להופעות ואירועי ספורט עולמיים.",
  "בלי ספסרים: קונים נטו במחיר העלות המקורי.",
  "נטוורקינג וקהילה: קהילה ישראלית שחיה ונושמת את האירועים הגדולים.",
  "ראשונים לדעת: גישה מוקדמת ובלעדית ששמורה רק לנו.",
];

const DEFAULT_IMAGES = [
  { src: "/images/giveaway/festival_confetti.png", alt: "פסטיבל" },
  { src: "/images/giveaway/f1_car.png", alt: "פורמולה 1" },
  { src: "/images/giveaway/soccer_ball.png", alt: "כדורגל" },
  { src: "/images/giveaway/fireworks.png", alt: "זיקוקים" },
];

export default function CommunitySection({ config }) {
  const benefits = config?.benefits ?? DEFAULT_BENEFITS;
  const images = config?.images ?? DEFAULT_IMAGES;

  return (
    <section dir="rtl" style={{ background: "#1A1A1A", padding: "80px 16px" }}>
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">

          {/* Text */}
          <div className="flex-1 text-right">
            <motion.div initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
              <p className="text-xs font-black uppercase tracking-widest mb-3" style={{ color: "#c8f135" }}>הקהילה שלנו</p>
              {config?.heading != null ? (
                <h2 className="font-black mb-5 text-white leading-tight" style={{ fontSize: "clamp(1.8rem, 3.5vw, 2.8rem)" }}>
                  {config.heading}
                </h2>
              ) : (
                <h2 className="font-black mb-5 text-white leading-tight" style={{ fontSize: "clamp(1.8rem, 3.5vw, 2.8rem)" }}>
                  חברי Mom3ntum<br />כבר ביציע
                </h2>
              )}
              <p className="text-sm md:text-base leading-relaxed mb-8" style={{ color: "rgba(255,255,255,0.75)", maxWidth: "420px" }}>
                {config?.description ?? `ליגת האלופות, מונדיאל, סופרקלאסיקו – חברי הקהילה שלנו כבר נהנים מגישה ישירה לאירועים הכי נחשקים בעולם, בזמן שאחרים מחפשים קומבינות ועדיין משלמים מאות אחוזים יותר על כרטיסים מהמחיר המקורי שלהם.`}
              </p>

              <div className="space-y-3">
                {benefits.map((item, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, x: 12 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: i * 0.07 }}
                    className="flex items-center gap-3 flex-row-reverse justify-end"
                  >
                    <span className="text-sm font-semibold" style={{ color: "rgba(255,255,255,0.75)" }}>{item}</span>
                    <div className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0"
                      style={{ background: "#c8f135" }}>
                      <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                        <path d="M2 5l2.5 2.5L8 3" stroke="#000" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </div>
                  </motion.div>
                ))}
              </div>
            </motion.div>
          </div>

          {/* Photo 2x2 grid */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="flex-1 w-full max-w-md"
          >
            <div className="relative">
              <div className="grid grid-cols-2 gap-1">
                <div className="rounded-tl-[30px] overflow-hidden aspect-square">
                  <img src={images[0]?.src ?? "/images/giveaway/festival_confetti.png"} alt={images[0]?.alt ?? "פסטיבל"} className="w-full h-full object-cover" />
                </div>
                <div className="overflow-hidden aspect-square">
                  <img src={images[1]?.src ?? "/images/giveaway/f1_car.png"} alt={images[1]?.alt ?? "פורמולה 1"} className="w-full h-full object-cover" />
                </div>
                <div className="rounded-bl-[30px] overflow-hidden aspect-square">
                  <img src={images[2]?.src ?? "/images/giveaway/soccer_ball.png"} alt={images[2]?.alt ?? "כדורגל"} className="w-full h-full object-cover" />
                </div>
                <div className="rounded-br-[30px] overflow-hidden aspect-square">
                  <img src={images[3]?.src ?? "/images/giveaway/fireworks.png"} alt={images[3]?.alt ?? "זיקוקים"} className="w-full h-full object-cover" />
                </div>
              </div>
              {/* Central Mom3ntum logo */}
              <div
                className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-[30px] flex items-center justify-center z-10"
                style={{ width: "102px", height: "102px", background: "#c8f135" }}
              >
                <img src="/images/giveaway/mom3ntum_icon.svg" alt="Mom3ntum" className="w-[60%] h-[60%] object-contain" />
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}